import { useCachedQuery } from '../../../shared/lib/queryCache';
import { tasksApi, type PipelineContext, type PipelineDivision } from '../../../shared/api/tasks.api';

/**
 * Кто текущий человек в конвейере: отделения, роль в каждом, команды.
 *
 * Нужен до любого запроса к конвейеру — все они требуют `divisionId`, а
 * взять его больше неоткуда. Кэшируем: за сессию состав отделений не меняется.
 */
export function usePipelineContext() {
  const query = useCachedQuery<PipelineContext>('pipeline:context', () => tasksApi.getContext());

  const divisions = query.data?.divisions ?? [];

  return {
    ...query,
    context: query.data ?? null,
    divisions,
    teams: query.data?.teams ?? [],
    /** Проекты отделений человека. Паблики внутри проекта экранам пока не нужны. */
    projects: query.data?.projects ?? [],
    /** Отделение, в которой у человека есть одна из ролей конвейера. */
    primaryDivision: divisions[0] ?? null,
    hasRole: (role: PipelineDivision['role']) => divisions.some((d) => d.role === role),
    /** Человек состоит в конвейере хоть в каком-то качестве. */
    inPipeline: divisions.length > 0,
  };
}
